export default "__VITE_ASSET__DnRxC2jZ__"